module.exports = BD.Model.extend({
    actor: BD.belongsTo('Billy.OAuthActor', { readonly: true }),
    createdTime: BD.attr('datetime', { readonly: true }),
    expires: BD.attr('datetime', { readonly: true }),
    material: BD.attr('string', { readonly: true })
})
